import { Component, OnInit } from '@angular/core';
import { AdminDashboardService, DashboardStats } from '../../_services/api/admin-dashboard.service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-dashboard',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './admin-dashboard.component.html',
  styleUrl: './admin-dashboard.component.scss'
})
export class AdminDashboardComponent implements OnInit {
  stats: DashboardStats | null = null;
  loading = false;
  error = '';
  showClosePeriodButton = true;

  constructor(
    private dashboardService: AdminDashboardService, 
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadDashboardStats();
  }

  loadDashboardStats(): void {
    this.loading = true;
    this.error = '';

    this.dashboardService.getDashboardStats().subscribe({
      next: (response) => {
        this.stats = response.data;
        this.loading = false;
      },
      error: (error) => {
        this.error = 'Failed to load dashboard statistics';
        this.loading = false;
        console.error('Error loading dashboard stats:', error);
      }
    });
  }

  gotToList(listName: string) {
    switch(listName) {
      case 'clients':
        this.router.navigate(['/admin/clients']); 
        break;    
      case 'reservations':
        this.router.navigate(['/admin/reservations']); 
        break;
      case 'agents':
        this.router.navigate(['/admin/agents']); 
        break;
    }
  }

   getStars(rating: number): string[] {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(i <= rating ? './assets/images/icons/star.png' : './assets/images/icons/empty-star.png');
    }
    return stars;
  }
}